import auth from "../Auth";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import * as React from "react";
import axios from "axios";
import { filterBy, groupBy } from "@progress/kendo-data-query";
import Skeleton from "react-loading-skeleton";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import withValueField from "../Shared/withValueField";
import { IDropDownModel } from "../Shared/Models/IDropDownModel";
import { ErrorComponent } from "../ReusableComponents";
import { Dialog } from "@progress/kendo-react-dialogs";
import lookup from "../Lookup/Services";
import { datetimeFormatter, errorToastr, successToastr, toLocalDateTime, convertTimeToUTC } from "../../HelperMethods";
import {
    ASSIGNED_DATES_ERROR_MSG, ASSIGNED_PROVIDERS_ERROR_MSG, PROVIDER_ASSIGNED_SUCCESS_MSG,
    REASSIGNED_PROVIDERS_ERROR_MSG,
    ASSIGNMENT_ALREADY_EXISTS_CONFIRMATION_MSG
} from "../Shared/AppMessages";
import { checkUntilInRecurrence, getPositionCount } from "../Scheduling/Common/Helper";
import ConfirmationModal from '../Shared/ConfirmationModal';

const CustomDropDownList = withValueField(DropDownList);

export interface AssignShiftProps {
    props: any;
    onCloseModal: any;
    scheduleId: string
    handleGetSchedule?: any;
}

export interface AssignShiftState {
    publishedScheduleId?: string;
    generatedScheduleId?: string;
    shiftId?: string;
    scheduleShiftId?: string;
    name?: string;
    position?: string;
    shiftType?: string;
    clientId: string;
    capacity?: any;
    duration?: any;
    submitted: boolean;
    showLoader?: boolean;
    shiftStartDate?: Date;
    shiftEndDate?: Date;
    providers: Array<IDropDownModel>;
    originalproviders: Array<IDropDownModel>;
    selectedProviders: any;
    positionId?: string;
    opened: boolean;
    scheduleAssignedShiftId?: any;
    recurrenceRule: string;
    showAlreadyExistModal: boolean;
    shiftTypeId: string;
}

class AssignShift extends React.Component<AssignShiftProps, AssignShiftState> {
    public totalCapacity: any;
    overWrite = false;
    constructor(props: AssignShiftProps) {
        super(props);
        this.state = {
            clientId: auth.getClient(),
            shiftStartDate: new Date(new Date(new Date().setHours(9)).setMinutes(0)),
            shiftEndDate: new Date(new Date(new Date().setHours(10)).setMinutes(0)),
            name: "",
            position: "",
            shiftType: "",
            submitted: false,
            showLoader: true,
            providers: [],
            originalproviders: [],
            selectedProviders: [],
            opened: false,
            recurrenceRule: 'FREQ=DAILY;INTERVAL=1',
            showAlreadyExistModal: false,
            shiftTypeId:""
        };
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        this.totalCapacity = this.props.props && this.props.props.no_of_pos && getPositionCount(this.props.props.start, this.props.props.noOfPosData, this.props.props.no_of_pos);
        if (this.props.props) {
            if (this.props.props.assignedId) {
                const selectedProviders = [{ id: this.props.props.candidateId, name: this.props.props.candidateName }];
                this.setState({ selectedProviders: selectedProviders, scheduleAssignedShiftId: this.props.props.assignedId });
            }
            this.setState({
                shiftId: this.props.props.shiftId,
                name: this.props.props.shiftName,
                shiftStartDate: this.props.props.start,
                shiftEndDate: this.props.props.end,
                position: this.props.props.title,
                shiftType: this.props.props.shiftTypeName,
                positionId: this.props.props.positionId,
                capacity: this.totalCapacity,
                shiftTypeId: this.props.props.shiftTypeId,
                recurrenceRule: this.props.props.recurrence
            }, () => { this.getProviders(this.props.props.positionId, datetimeFormatter(this.props.props.start), datetimeFormatter(this.props.props.end), datetimeFormatter(this.props.props.shiftStartTime), datetimeFormatter(this.props.props.shiftEndTime)); });
        }
    }

    getProviders = (positionId, shiftStartDate, shiftEndDate, startTime, endTime) => {
        this.setState({ showLoader: false });
        lookup.getSuggestedCandidatesLookup(positionId, shiftStartDate, shiftEndDate, convertTimeToUTC(startTime), convertTimeToUTC(endTime),
            auth.getClient(), this.state.shiftTypeId, new Date(startTime).toLocaleTimeString(), new Date(endTime).toLocaleTimeString())
            .then(async res => {
                const ungrouped = 'Ungrouped';
                const candidatesWithUngrouped = res.data.map((el) => (el.position ? el : { ...el, position: ungrouped }));
                this.setState({ opened: true })
                const groupedData = (groupBy(candidatesWithUngrouped, [{ field: 'candidateType' }]) as any[]).reduce(
                    (res, group) => [...res, ...group.items],
                    []
                )


                this.setState({ providers: groupedData, originalproviders: groupedData });
            });
    }

    handleFilterChange(event) {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }

    filterData(filter, originalArray) {
        const data1 = this.state[originalArray];
        return filterBy(data1, filter);
    }

    isCustom = (item) => { return item.id === undefined; }

    addKey = (item) => { item.id = undefined }

    handleProviderChange = (e) => {
        this.setState({ selectedProviders: e.value });
    }
    overWriteAvailabilty() {
        this.overWrite = true;
        this.setState({ showAlreadyExistModal: false });
        this.handleSave();
    }

    handleSave = () => {
        this.setState({ submitted: true })

        var rule = this.state.recurrenceRule;
        rule = checkUntilInRecurrence(rule, this.state.shiftEndDate);

        let selectedProviderids = [];
        this.state.selectedProviders.forEach((item) => {
            selectedProviderids.push(item.id);
        });
        var allocatedCapacity = this.state.selectedProviders.length;

        let isValid = this.checkValidations(allocatedCapacity, this.state.capacity, this.state.shiftStartDate, this.state.shiftEndDate, this.props.props.assignedId);
        if (isValid) {
            let data = {
                schedulePublishedShiftId: this.props.props.publishedId,
                scheduleGeneratedShiftId: this.props.props.generatedId,
                allocatedCapacity: allocatedCapacity,
                startDate: toLocalDateTime(this.state.shiftStartDate),
                endDate: toLocalDateTime(this.state.shiftEndDate),
                providerIds: selectedProviderids,
                scheduleAssignedShiftId: this.props.props.assignedId,
                recurrenceRule: rule,
                overWrite:this.overWrite,
                recurrenceException: this.state.shiftStartDate != null ? this.state.shiftStartDate.toString() : "",
                isSingleAssign: true
            };
            if ((this.state.name != undefined && this.state.name != null && this.state.name != "") && (this.state.position != undefined && this.state.position != null && this.state.position != "") && (this.state.shiftType != undefined && this.state.shiftType != null && this.state.shiftType != "") && (this.state.shiftStartDate != undefined && this.state.shiftStartDate != null)
                && (this.state.shiftEndDate != undefined && this.state.shiftEndDate != null) && (this.state.selectedProviders != undefined && this.state.selectedProviders.length > 0 && this.state.selectedProviders != null)) {
                if (this.props.props.assignedId) {
                    axios.patch(`api/scheduling/published/${this.props.props.publishedId}/assign`, JSON.stringify(data)).then((res) => {
                        successToastr(PROVIDER_ASSIGNED_SUCCESS_MSG);
                        this.props.onCloseModal();
                        this.props.handleGetSchedule(this.props.scheduleId);
                    });
                } else {
                    axios.post(`api/scheduling/published/${this.props.props.publishedId}/assign`, JSON.stringify(data)).then((res) => {
                        if (res.data == -999) {
                            this.setState({ showAlreadyExistModal: true });
                            this.overWrite = false;
                            return;
                        }
                        this.overWrite = false;
                        successToastr(PROVIDER_ASSIGNED_SUCCESS_MSG);
                        this.props.onCloseModal();
                        this.props.handleGetSchedule(this.props.scheduleId);
                    });
                }
            }
        }
    }

    checkValidations(allocatedCapacity, capacity, startDate, endDate, assignedId) {
        if(assignedId && allocatedCapacity > 1){
            errorToastr(REASSIGNED_PROVIDERS_ERROR_MSG);
            return false;
        }
        if (allocatedCapacity != null && allocatedCapacity != undefined && allocatedCapacity > capacity) {
            errorToastr(ASSIGNED_PROVIDERS_ERROR_MSG);
            return false;
        }
        if (startDate != null && endDate != undefined && startDate > endDate) {
            errorToastr(ASSIGNED_DATES_ERROR_MSG);
            return false;
        }
        return true;
    }
    groupHeaderItemRender = (li) => {
        const itemHeader = (
            <b
                style={{
                    textAlign: 'left'
                }}
            >
                {li.props.children}
            </b>
        );
        return React.cloneElement(li, li.props, itemHeader);
    };

    stickyHeaderRender = (div) => {
        const item = (
            <span
                style={{
                    fontWeight: 900,
                    width: '100%',
                    textAlign: 'left'
                }}
            >
                {div.props.children}
            </span>
        );
        return React.cloneElement(div, div.props, item);
    };


    render() {
        return (
            <Dialog title="Assign Shifts" onClose={this.props.onCloseModal}>
                <div className="row mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end holdposition-width">
                    <div className="modal-content border-0">
                        {this.state.showLoader &&
                            Array.from({ length: 2 }).map((item, i) => (
                                <div className="row mx-auto mt-2" key={i}>
                                    {Array.from({ length: 3 }).map((item, j) => (
                                        <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                            <Skeleton width={230} />
                                            <Skeleton height={30} />
                                        </div>
                                    ))}
                                </div>
                            ))}
                        {!this.state.showLoader && (
                            <div className="model-body">
                                <div className="row mt-3 mx-0">
                                <div className="col-12 col-sm-4 mt-1 mt-sm-0">
                                        <label className="mb-0 font-weight-bold required">Shift Type</label>
                                        <input
                                            type="text"
                                            className="form-control mt-1"
                                            placeholder="Enter Shift Type"
                                            value={this.state.shiftType}
                                            maxLength={100}
                                            onChange={(event) => {
                                                this.setState({ shiftType: event.target.value });
                                            }}
                                            disabled={true}
                                        />
                                        {this.state.submitted && (this.state.shiftType.trim() == undefined || this.state.shiftType.trim() == null || this.state.shiftType.trim() == "") && <ErrorComponent />}
                                    </div>
                                    <div className="col-sm-4 mt-1 mt-sm-0">
                                        <label className="mb-0 font-weight-bold required">Shift</label>
                                        <input
                                            type="text"
                                            className="form-control mt-1"
                                            placeholder="Enter Shift Name"
                                            value={this.state.name}
                                            maxLength={100}
                                            onChange={(event) => {
                                                this.setState({ name: event.target.value });
                                            }}
                                            disabled={true}
                                        />
                                        {this.state.submitted && (this.state.name.trim() == undefined || this.state.name.trim() == null || this.state.name.trim() == "") && <ErrorComponent />}
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-4 mt-1 mt-sm-0" id="ShowDatePickerIcon">
                                        <label className="mb-1 font-weight-bold required">Shift Date</label>
                                        <div className="row">
                                            <div className="col-12">
                                                <DatePicker
                                                    className="form-control"
                                                    format="MM/dd/yyyy"
                                                    name="shiftStartTime"
                                                    value={this.state.shiftStartDate}
                                                    min={new Date(this.state.shiftStartDate)}
                                                    max={new Date(this.state.shiftEndDate)}
                                                    onChange={(e) => this.setState({ shiftStartDate: e.target.value })}
                                                    disabled={true}
                                                    formatPlaceholder="formatPattern"
                                                />
                                                {this.state.submitted && (this.state.shiftStartDate == undefined || this.state.shiftStartDate == null) && <ErrorComponent />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3 mx-0">
                                    <div className="col-12 col-sm-4 mt-1 mt-sm-0">
                                        <label className="mb-0 font-weight-bold required">Position</label>
                                        <input
                                            type="text"
                                            className="form-control mt-1"
                                            placeholder="Enter Shift Name"
                                            value={this.state.position}
                                            maxLength={100}
                                            onChange={(event) => {
                                                this.setState({ position: event.target.value });
                                            }}
                                            disabled={true}
                                        />
                                        {this.state.submitted && (this.state.position.trim() == undefined || this.state.position.trim() == null || this.state.position.trim() == "") && <ErrorComponent />}
                                    </div>
                                    <div className="col-sm-4 mt-sm-0 mt-2" id="removemargin-border">
                                        <label className="mb-1 font-weight-bold">No. Of Position Required</label>
                                        <NumericTextBox
                                            className="form-control text-right"
                                            disabled={true}
                                            name="duration"
                                            placeholder="Enter Duration"
                                            value={this.state.capacity}
                                            title="Maximum value could be 99999."
                                            max={99999}
                                            min={0}
                                            spinners={false}
                                        />
                                    </div>
                                    {/* <div className="col-12 col-sm-6 col-md-4 col-lg-4 mt-1 mt-sm-0" id="ShowDatePickerIcon">
                                        <label className="mb-1 font-weight-bold  required">End Date</label>
                                        <div className="row">
                                            <div className="col-12">
                                                <DatePicker
                                                    className="form-control"
                                                    format="MM/dd/yyyy"
                                                    name="endDateTime"
                                                    value={this.state.shiftEndDate}
                                                    min={new Date(this.state.shiftStartDate)}
                                                    max={new Date(this.state.shiftEndDate)}
                                                    onChange={(e) => this.setState({ shiftEndDate: e.target.value })}
                                                    disabled={true}
                                                    formatPlaceholder="formatPattern"
                                                />
                                                {this.state.submitted && (this.state.shiftEndDate == undefined || this.state.shiftEndDate == null) && <ErrorComponent />}
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="row mt-3 mx-0">
                                    <div className="col-12 col-sm-8 col-lg-8 mt-1 mt-sm-0">
                                        <label className="mb-1 font-weight-bold required">Provider</label>
                                        <MultiSelect
                                            className="form-control disabled"
                                            data={this.state.providers}
                                            groupField="candidateType"
                                            textField="name"
                                            dataItemKey="id"
                                            id="providers"
                                            value={this.state.selectedProviders}
                                            placeholder="Select Provider..."
                                            onChange={(e) => this.handleProviderChange(e)}
                                            filterable={true}
                                            onFilterChange={this.handleFilterChange}
                                            groupHeaderItemRender={this.groupHeaderItemRender}
                                            groupStickyHeaderItemRender={this.stickyHeaderRender}
                                        />
                                        {this.state.submitted && (this.state.selectedProviders == undefined || this.state.selectedProviders.length == 0 || this.state.selectedProviders == null) && <ErrorComponent />}
                                    </div>
                                </div>
                            </div>
                        )}


                        <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                            <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                                <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.onCloseModal}>
                                    <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                                </button>
                                <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleSave}>
                                    <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Assign Shifts
                                </button>
                            </div>
                        </div>
                    </div>
                    </div>
                    <ConfirmationModal
                        message={ASSIGNMENT_ALREADY_EXISTS_CONFIRMATION_MSG()}
                        showModal={this.state.showAlreadyExistModal}
                        handleYes={() => this.overWriteAvailabilty()}
                        handleNo={() => {
                            this.setState({ showAlreadyExistModal: false });
                        }}
                    />
            </Dialog>
        );
    }
}
export default AssignShift;